import React from 'react';
import Icon, { IconProps } from '../Icon';

const ErrorIconCircle: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6389 25.2778C10.1392 25.2778 7.69556 24.5365 5.6171 23.1477C3.53865 21.759 1.91869 19.785 0.962084 17.4756C0.00547622 15.1661 -0.244816 12.6249 0.242858 10.1732C0.730533 7.72147 1.93427 5.46943 3.70185 3.70185C5.46943 1.93427 7.72147 0.730533 10.1732 0.242858C12.6249 -0.244816 15.1661 0.00547622 17.4756 0.962084C19.785 1.91869 21.759 3.53865 23.1477 5.6171C24.5365 7.69556 25.2778 10.1392 25.2778 12.6389C25.274 15.9898 23.9412 19.2023 21.5717 21.5717C19.2023 23.9412 15.9898 25.274 12.6389 25.2778V25.2778ZM12.6389 1.16667C10.3699 1.16667 8.15187 1.83951 6.26527 3.10009C4.37867 4.36067 2.90825 6.15239 2.03994 8.24866C1.17164 10.3449 0.944449 12.6516 1.38711 14.877C1.82977 17.1024 2.92239 19.1466 4.52681 20.751C6.13123 22.3554 8.17538 23.448 10.4008 23.8907C12.6262 24.3333 14.9328 24.1062 17.0291 23.2378C19.1254 22.3695 20.9171 20.8991 22.1777 19.0125C23.4383 17.1259 24.1111 14.9079 24.1111 12.6389C24.1077 9.59731 22.898 6.68128 20.7472 4.53056C18.5965 2.37984 15.6805 1.17007 12.6389 1.16667V1.16667Z"
          fill="currentColor"
        />
        <path
          d="M13.59 14.144H12.246V7.088H13.59V14.144ZM12.022 16.16C12.022 15.908 12.1107 15.6933 12.288 15.516C12.4747 15.3293 12.694 15.236 12.946 15.236C13.198 15.236 13.4127 15.3293 13.59 15.516C13.7767 15.6933 13.87 15.908 13.87 16.16C13.87 16.412 13.7767 16.6313 13.59 16.818C13.4127 16.9953 13.198 17.084 12.946 17.084C12.694 17.084 12.4747 16.9953 12.288 16.818C12.1107 16.6313 12.022 16.412 12.022 16.16Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default ErrorIconCircle;
